<template>
  <div class="custom-font-regular">
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{
        toolbarTitle
      }}</v-toolbar-title>
      <v-btn small light @click="seeHistory" class="history-button blue--text" v-if="!hideHistory">
          <v-icon small color="blue" class="icon-build">history</v-icon>
          <span>Historial</span>
        </v-btn>
      <HistoryDialog ref="history" :history="history" v-if="!hideHistory"></HistoryDialog>
      <v-spacer></v-spacer>
      <div>
      <ConfirmationDialog
          ref="confirmVolver"
          :function-yes="bindingFunctionVolver"
          title="¿Volver?"
          text="¿Seguro desea descartar los cambios?"
        ></ConfirmationDialog>
        <ConfirmationDialog
          ref="confirmReturn"
          :function-yes="bindingFunction"
          title="¿Volver a Presentado?"
          text="¿Seguro que desea volver este informe a estado presentado?"
        ></ConfirmationDialog>
       <v-btn class="mx-0"  @click="goBackBinding">Volver </v-btn>
      </div>
         <!--dOWNLOADPDF TODO: VALIDAR CUANDO SE MUESTRA-->
      <div v-if="showPDFDownload"><v-btn class="mx-1 white--text" color="#1787c9"  @click="getVisibility">PDF </v-btn></div>
      <div v-if="showPDFDownloadGeneral && hidePdfButton"><v-btn class="mx-1 white--text" color="#1787c9"  @click="getPdfGeneral">PDF. </v-btn></div>
      <div v-if="showExcelDownload"><v-btn class="mx-1 white--text" color="#85bb65"  @click="downloadExcel">Excel</v-btn></div>
     <div v-if="canReturnToPresent">
      <v-btn
      color="#FFA500"
      class="black--text"
      @click="volverPresentado"
      >Volver a Presentado</v-btn>
      </div>

      <v-btn
        v-if="canSave"
        color="#1787c9"
        class="submit-button white--text"
        @click="submitAll"
        > Guardar</v-btn
      >

      <div v-if="canEdit" class="d-flex align-center " style="gap:10px;">
        <InformeAuditoriaActionButtonsAuditor
          :canEdit="canEdit"
          :complete="isComplete"
          :change="isChange"
          @click="handlePresentarClick"
        ></InformeAuditoriaActionButtonsAuditor>
      </div>
      <div v-if="canApprove" class="d-flex align-center " style="gap:10px;">
        <InformeAuditoriaActionButtonsAprobador
          :canApprove="canApprove"
          :change="isChange"
          :item="informe"
        ></InformeAuditoriaActionButtonsAprobador>

      </div>
      <div v-if="isOwner && canEdit">
        <ConfirmationDialog
          ref="confirmDelete"
          :function-yes="bindingFunction"
          title="¿Borrar Informe?"
          text="¿Seguro desea borrar el informe?"
        ></ConfirmationDialog>
        <v-btn
          v-if="canEdit && $store.getters.isSafRole"
          color="#BD2A0B"
          class="submit-button white--text"
          @click="deleteReport"
          >Eliminar</v-btn
        >
      </div>
      <div v-if="isChange">
          <p style="color:red;">Tiene cambios pendientes de Guardar</p>
        </div>
    </v-toolbar>
    <v-container grid-list-xl mt-5 pt-5>
      <div v-if="loading">
        <v-flex offset-xs5 pa-5>
          <v-progress-circular
            :size="100"
            :width="5"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </div>
      <div v-else>
        <v-toolbar class="header-element">
          <v-toolbar-title>{{ informe.description }}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <DescripcionGeneral :item="informe" @updateGoals="updateGoals"></DescripcionGeneral>
        <Comments v-if="viewGeneralComments" :informe="informe"></Comments>
        <DischargeLocal v-if="viewDischargeLocalComments" :informe="informe"></DischargeLocal>
        <DischargeVisitor v-if="viewDischargeVisitorComments" :informe="informe"></DischargeVisitor>
        <div v-for="section in informe.sections"

         :key="section.id">
         <div
         v-if="hasFieldWithVisibility(section)">
          <v-divider></v-divider>
          <v-toolbar class="header-element">
            <v-toolbar-title>{{ section.description }}</v-toolbar-title>
          </v-toolbar>
          <v-card class="d-flex">
            <v-layout wrap>
              <div
                v-for="(field, index) in section.sectionFields"
                :key="field.id"
                class="pa-1"
                style="width:100%;"
              >
                <FieldDetail
                  v-if="hasVisibility(field)"
                  @updateListField="updaAllFields"
                  :field="field"
                  :index="index"
                  :status="status"
                  :username="username"
                  :listClubesContactos="listClubesContactos"
                  :mandatoryFieldsAreComplete="mandatoryFieldsAreComplete"
                ></FieldDetail>
              </div>
              <!--end for fields-->
            </v-layout>
            <v-divider></v-divider>
          </v-card>
          <v-divider></v-divider>
        </div>
        </div>
      </div>
      <div
        class="mx-4"
        style="display: flex; align-items: center; justify-content:center;"
      >
        <div style="margin-top: 12px;">
      <ConfirmationDialog
          ref="confirmVolver"
          :function-yes="bindingFunctionVolver"
          title="¿Volver?"
          text="¿Seguro desea descartar los cambios?"
        ></ConfirmationDialog>
       <v-btn class="mx-0" @click="goBackBinding" >Volver</v-btn>
      </div>
        <v-btn
          v-if="canSave"
          color="#1787c9"
          class="submit-button white--text"
          @click="submitAll"
          >Guardar</v-btn
        >
        <div v-if="canEdit" style="margin-top: 12.5px;">
          <InformeAuditoriaActionButtonsAuditor
            :canEdit="canEdit"
            :complete="isComplete"
            :change="isChange"
            @click="handlePresentarClick"
          ></InformeAuditoriaActionButtonsAuditor>
        </div>
        <div v-if="canApprove" class="mx-3" style="margin-top: 12.5px;">
          <InformeAuditoriaActionButtonsAprobador
            :canApprove="canApprove"
            :change="isChange"
            :item="informe"
          ></InformeAuditoriaActionButtonsAprobador>
        </div>
      </div>
    </v-container>
    <!--V-DIalog start-->
    <v-dialog
      v-model="dialog"
      max-width="390"
    >
      <v-card>
        <v-card-title class="headline">Elija usuario final del Informe</v-card-title>

        <v-card-text style="text-align:center;">
          <div><v-btn class="mx-1" style="width:150px;" color="primary" @click="getVisibilityOption(Constants.INFORME_FIELD_VISIBILITY_LOCAL)">Equipo Local</v-btn></div>
          <div><v-btn class="mx-1" style="width:150px;" color="primary" @click="getVisibilityOption(Constants.INFORME_FIELD_VISIBILITY_VISITANTE)">Equipo Visitante</v-btn></div>
          <div><v-btn class="mx-1" style="width:150px;" color="primary" @click="getVisibilityOption(Constants.INFORME_FIELD_VISIBILITY_TODOS)">Ambos Equipos</v-btn></div>
          <div><v-btn class="mx-1" style="width:150px;" color="primary" @click="getVisibilityOption(Constants.INFORME_FIELD_VISIBILITY_LIGA)">LPF</v-btn></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--V-DIalog end-->
    <v-tooltip v-if="online" left>
      <template v-slot:activator="{ on, attrs }">
    <v-btn v-if="canSave" @click="submitAll" v-bind="attrs" v-on="on" app dark fixed fab bottom :class="{'add-button': true, 'fab-informe-guardado': true}">
        <v-icon>save</v-icon>
    </v-btn>
  </template>
  <span>Guardar</span>
  </v-tooltip>
  <v-tooltip v-else left>
      <template v-slot:activator="{ on, attrs }">
    <v-btn v-if="canSave" v-bind="attrs" v-on="on" app dark fixed fab bottom :class="{'add-button': true,'offline-button': true}">
        <v-icon color="#5e5757">mdi-wifi-off</v-icon>
    </v-btn>
  </template>
  <span>Sin conexión para guardar</span>
  </v-tooltip>
  </div>
</template>

<script>
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import Constants from '../../../common/constants'
import DescripcionGeneral from '../components/InformeAuditoriaDescripcionGeneral.vue'
import FieldDetail from '../components/InformeAuditoriaFieldDetail.vue'
import InformeAuditoriaActionButtonsAuditor from '../components/fields_components/InformeAuditoriaActionButtonsAuditor.vue'
import InformeAuditoriaActionButtonsAprobador from '../components/fields_components/InformeAuditoriaActionButtonsAprobador.vue'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import Comments from '../components/InformeAuditoriaComments.vue'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import DischargeLocal from '../components/InformeAuditoriaDischargeLocal.vue'
import DischargeVisitor from '../components/InformeAuditoriaDischargeVisitor.vue'
import HistoryDialog from '../../../features/presentacion/components/HistoryDialog.vue'

export default {
  mixins: [s3UploadMixin, downloadFileMixin],
  props: {
    fetchPath: {
      type: String,
      default: 'informe-auditoria'
    },
    toolbarTitle: {
      type: String,
      default: 'Informe /Auditoria'
    },
    typeLabel: {
      type: String,
      default: 'Tipo de Informe'
    },
    typeLabelHide: {
      type: Boolean,
      default: false
    },
    descripionLabel: {
      type: String,
      default: 'Descripción'
    },
    period: Boolean,
    submitPath: {
      type: String,
      default: 'informe-auditoria-update'
    },
    actionButtonsPrefix: {
      type: String,
      default: 'InformeAuditoriaActionButtons'
    },
    deletePath: {
      type: String,
      default: 'informe-auditoria-delete'
    },
    pdfPath: {
      type: String,
      default: 'informe-auditoria/pdf-informe'
    },
    pdfGeneralPath: {
      type: String,
      default: 'informe-auditoria/pdf-general-informe'
    }
  },

  components: {
    DescripcionGeneral,
    FieldDetail,
    InformeAuditoriaActionButtonsAuditor,
    InformeAuditoriaActionButtonsAprobador,
    ConfirmationDialog,
    Comments,
    DischargeLocal,
    DischargeVisitor,
    HistoryDialog
  },

  data () {
    return {
      loading: false,
      informe: {},
      isMounted: false,
      status: null,
      change: false,
      bindingFunction: null,
      username: null,
      bindingFunctionVolver: null,
      visibility: null,
      dialog: false,
      Constants,
      listClubesContactos: [],
      mandatoryFieldsAreComplete: null,
      online: navigator.onLine,
      history: []
    }
  },

  computed: {
    isModified () {
      if (!this.isMounted) return false
      return false
    },
    canEdit () {
      if (this.informe && this.informe.report && this.informe.report.typeReport && this.informe.report.typeReport.isClub) {
        if (this.informe.club && (this.informe.club.nombre === this.$store.state.authUser.club) &&
            this.$store.state.permissions.canPresentInformesAuditorias) {
          return true
        }
      }
      return (
        (this.status === Constants.INFORME_STATUS_EN_CARGA &&
          this.$store.state.permissions.canPresentInformesAuditorias) ||
        (this.status === Constants.INFORME_STATUS_DEVUELTA &&
          this.$store.state.permissions.canPresentInformesAuditorias)
      )
    },
    canApprove () {
      return (
        this.status === Constants.INFORME_STATUS_PRESENTADO &&
        this.$store.state.permissions.canApproveInformesAuditorias
      )
    },
    canReturnToPresent () {
      return (
        (this.status === Constants.INFORME_STATUS_APROBADO) &&
        this.$store.state.permissions.canReturnToPresentInformesAuditorias
      )
    },
    isComplete () {
      let presentar = true
      let fieldToPresent = this.informe.sections
        .map(section => section.sectionFields)
        .flat()
      fieldToPresent.map(field => {
        if (
          (field.mandatory && field.responseValue === '') ||
          (field.requireScale && field.scaleValue === '')
        ) {
          presentar = false
          return presentar
        }
      })
      if (!this.checkPenalties()) {
        presentar = false
      }
      return presentar
    },
    isChange () {
      return this.change
    },
    canSave () {
      return (
        (this.status === Constants.INFORME_STATUS_EN_CARGA &&
          this.$store.state.permissions.canPresentInformesAuditorias) ||
        (this.status === Constants.INFORME_STATUS_PRESENTADO &&
          this.$store.state.permissions.canApproveInformesAuditorias) ||
        (this.status === Constants.INFORME_STATUS_DEVUELTA &&
          this.$store.state.permissions.canPresentInformesAuditorias)
      )
    },
    viewGeneralComments () {
      return (this.status !== Constants.INFORME_STATUS_APROBADO)
    },
    showPDFDownload () {
      return ((this.status === Constants.INFORME_STATUS_APROBADO) && (this.informe.partido != null))
    },
    showPDFDownloadGeneral () {
      return ((this.status === Constants.INFORME_STATUS_APROBADO) && (this.informe.club != null))
    },
    showExcelDownload () {
      return ((this.status === Constants.INFORME_STATUS_APROBADO) && (this.informe.partido != null) &&
               this.$store.state.permissions.canApproveInformesAuditorias)
    },
    viewDischargeLocalComments () {
      return (this.status === Constants.INFORME_STATUS_APROBADO) && this.isInformePartido() &&
      (this.userClubIsLocal() || this.$store.state.permissions.canApproveInformesAuditorias)
    },
    viewDischargeVisitorComments () {
      return (this.status === Constants.INFORME_STATUS_APROBADO) && this.isInformePartido() &&
      (this.userClubIsVisitor() || this.$store.state.permissions.canApproveInformesAuditorias)
    },
    hideHistory () {
      if (this.informe.report) {
        return !this.informe.report.typeReport.isClub
      } else return true
    },
    hidePdfButton () {
      if (this.informe.report) {
        if (this.informe.report.typeReport.isClub) {
          if (this.$store.getters.isSafRole) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },

  methods: {
    getAttachmentName (attachment) {
      return attachment
        .split('/')
        .slice(-1)
        .pop()
    },
    fetchData () {
      this.loading = true
      this.axios
        .get(`${this.fetchPath}/${this.$route.params.id}`)
        .then(response => {
          this.informe = response.data
          /* if (this.informe.club != null) { this.listClubesContactos.push(this.informe.club.id) }
          if (this.informe.partido != null) {
            this.listClubesContactos.push(this.informe.partido.clubLocal.id)
            this.listClubesContactos.push(this.informe.partido.clubVisitor.id)
          } */
          this.status = response.data.status
          this.history = response.data.history
          // this.username = response.data.author.username
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    updaAllFields (field) {
      this.change = true
      let sectionId = field.reportResponseSection.id
      this.informe.sections.forEach((sections, i) => {
        if (sections.pk === sectionId) {
          sections.sectionFields.forEach((f, j) => {
            if (f.id === field.id) {
              this.$set(
                this.informe.sections[i].sectionFields[j],
                'fieldAdjuntos',
                field.fieldAdjuntos
              )
              this.$set(
                this.informe.sections[i].sectionFields[j],
                'incumplimiento',
                field.incumplimiento
              )
            }
          })
        }
      })
    },
    submitAll () {
      this.saving = true
      this.submit()
    },
    submit () {
      this.saving = true

      const allFields = this.informe.sections
        .map(section => section.sectionFields)
        .flat()

      const specialFields = allFields.filter(f => f.allowMultiple && f.dataType && f.dataType.isGeneric)
      const payload = {
        informe: this.informe,
        fields: allFields
      }

      this.axios
        .put(`${this.submitPath}`, payload)
        .then(response => {
          if (specialFields.length > 0) {
            this.saveSpecialEndpoint(specialFields)
          } else {
            this.finalizeSubmit()
          }
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    saveSpecialEndpoint (specialFields) {
      let dataToSave = []

      specialFields.forEach(field => {
        let rawValue = field.responseValue
        let values = []

        if (typeof rawValue === 'string' && rawValue.startsWith('[')) {
          try {
            rawValue = JSON.parse(rawValue)
          } catch (e) {
            return e
          }
        }

        if (Array.isArray(rawValue)) {
          values = rawValue
        } else if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
          values = [rawValue]
        }

        if (values.length > 0) {
          values.forEach(valueId => {
            dataToSave.push({
              report_response_field: field.id,
              type_data_generic_value: parseInt(valueId, 10),
              text_value: ''
            })
          })
        } else {
          dataToSave.push({
            report_response_field: field.id,
            type_data_generic_value: null,
            text_value: ''
          })
        }
      })

      if (dataToSave.length === 0) return

      this.axios
        .post('/informe-auditoria/multiple-generic-value/create', dataToSave)
        .then(() => {
          this.finalizeSubmit()
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    finalizeSubmit () {
      this.saving = false
      this.change = false
    },
    delete () {
      this.axios
        .delete(`${this.deletePath}/${this.informe.pk}`)
        .then(response => {
          this.$router.go(-1)
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    deleteReport () {
      this.bindingFunction = this.delete
      this.$refs.confirmDelete.openDialog()
    },
    isOwner () {
      return this.informe.author.username === this.$store.state.authUser
    },
    goBackBinding () {
      if (this.change) {
        this.bindingFunctionVolver = this.goBack
        this.$refs.confirmVolver.openDialog()
      } else {
        this.goBack()
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    hasVisibility (field) {
      if (this.isInformeGeneral()) {
        if ((Constants.INFORME_FIELD_VISIBILITY_LIGA === field.visibility && !this.$store.getters.isSafRole)) {
          return false
        } else {
          return true
        }
      } else {
        return ((Constants.INFORME_FIELD_VISIBILITY_LOCAL === field.visibility && this.userClubIsLocal()) ||
      (Constants.INFORME_FIELD_VISIBILITY_VISITANTE === field.visibility && this.userClubIsVisitor()) ||
      (Constants.INFORME_FIELD_VISIBILITY_TODOS === field.visibility) || (this.userIsSaf()))
      }
    },
    userClubIsLocal () {
      return this.$store.getters.club === this.informe.partido.clubLocal.nombre
    },
    userClubIsVisitor () {
      return this.$store.getters.club === this.informe.partido.clubVisitor.nombre
    },
    userIsSaf () {
      return this.$store.getters.isSafRole
    },
    downloadPDF () {
      this.loading = true
      let payload = {
        informe: this.informe,
        visibility: this.visibility
      }
      this.axios
        .post(`${this.pdfPath}`, payload)
        .then(response => {
          this.forceFileDownload(response, this.getFilenamePrefix(), 'pdf')
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loading = false
        })
    },
    forceFileDownload (response, filename, extension) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}_${Date.now().toString()}.${extension}`)
      document.body.appendChild(link)
      link.click()
    },
    getFilenamePrefix () {
      let name = 'informe'
      if (this.informe.partido != null) {
        name = `Informe_${this.informe.partido.description}_${this.informe.partido.fecha.description}_${this.informe.partido.fecha.tournament.description}`
      }
      if (this.informe.club != null) {
        name = `Informe_${this.informe.club.description}`
      }
      if (this.informe.club != null) {
        name = `Informe_Club_${this.informe.club.nombre}`
      }

      return name
    },
    getVisibility () {
      if (this.$store.getters.isClubRole) {
        this.visibility = (this.userClubIsLocal()) ? Constants.INFORME_FIELD_VISIBILITY_LOCAL : Constants.INFORME_FIELD_VISIBILITY_VISITANTE
        this.downloadPDF()
      } else if (this.$store.getters.isSafRole) {
        this.dialog = true
      }
    },
    getVisibilityOption (option = Constants.INFORME_FIELD_VISIBILITY_LOCAL) {
      this.visibility = option
      this.downloadPDF()
      this.dialog = false
    },
    updateGoals (item) {
      this.change = true
      this.informe.localGoals = Number(item.localGoals)
      this.informe.visitorGoals = Number(item.visitorGoals)
      this.informe.localPenaltyGoals = item.localPenaltyGoals
      this.informe.visitorPenaltyGoals = item.visitorPenaltyGoals
    },
    getPdfGeneral () {
      this.downloadGeneralPDF()
    },
    downloadGeneralPDF () {
      this.loading = true
      let payload = {
        informe: this.informe,
        visibility: Constants.INFORME_FIELD_VISIBILITY_LIGA
      }
      this.axios
        .post(`${this.pdfGeneralPath}`, payload)
        .then(response => {
          this.forceFileDownload(response, this.getFilenamePrefix(), 'pdf')
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.loading = false
        })
    },
    hasFieldWithVisibility (section) {
      if (this.isInformeGeneral()) {
        return true
      }
      let fieldsOfSection = section.sectionFields.flat()
      if (this.userClubIsLocal()) {
        return (fieldsOfSection.some(field => field.visibility === Constants.INFORME_FIELD_VISIBILITY_LOCAL ||
             field.visibility === Constants.INFORME_FIELD_VISIBILITY_TODOS))
      } else if (this.userClubIsVisitor()) {
        return (fieldsOfSection.some(field => field.visibility === Constants.INFORME_FIELD_VISIBILITY_VISITANTE ||
             field.visibility === Constants.INFORME_FIELD_VISIBILITY_TODOS))
      } else {
        return true
      }
    },
    volverPresentado () {
      this.bindingFunction = () => {
        this.loading = true
        this.axios
          .put(`/informe-auditoria/presentar-return/${this.$route.params.id}`)
          .then(() => {
            this.loading = false
            this.$router.go(-1)
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('setErrorMsg', error)
          })
      }
      this.$refs.confirmReturn.openDialog()
    },
    getFilteringPath () {
      return `informe=${this.$route.params.id}`
    },
    getExcelPath () {
      return `informe-auditoria/informe-partido/xls` + '?' + this.getFilteringPath()
    },
    isInformeGeneral () {
      return this.informe.report.modulo.id === Constants.INFORME_MODULO_GENERAL
    },
    isInformePartido () {
      return this.informe.report.modulo.id === Constants.INFORME_MODULO_PARTIDO
    },
    handlePresentarClick (isReadyToPresentar) {
      this.mandatoryFieldsAreComplete = isReadyToPresentar
    },
    checkPenalties () {
      if (this.informe.localPenaltyGoals !== null && this.informe.visitorPenaltyGoals === null) {
        return false
      } else if (this.informe.visitorPenaltyGoals !== null && this.informe.localPenaltyGoals === null) {
        return false
      } else {
        return true
      }
    },
    updateOnlineStatus () {
      this.online = navigator.onLine
    },
    handleFabButtonClick () {
      if (this.online) {
        this.submitAll()
      }
    },
    seeHistory () {
      this.$refs.history.showDialog()
    }
  },
  created () {
    this.fetchData()
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  mounted () {
    this.isMounted = true
  },
  beforeDestroy () {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },

  watch: {
    'online' () {
      if (!this.online) {
        this.$store.commit('setCustomErrorMsg', 'Se ha perdido la conexión a internet')
      } else {
        this.$store.state.globalInfo = 'Conexión a internet recuperada'
      }
    }
  }

}
</script>

<style scoped>
.header-element {
  background-color: #293968;
  color: white;
}
pre {
  line-height: 1.5;
}
.communication-description {
  white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
  white-space: -pre-wrap; /* Opera */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
  word-wrap: break-word; /* IE 5.5+ */
  width: 100%;
}

.custom-font-regular {
  font-family: SourceSansProRegular, sans-serif;
}

.fab-informe-guardado {
  position: fixed;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
}
.offline-button {
  position: fixed;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background-color: #e2dcdc !important;
  opacity: 1 !important;
  cursor: auto;

}
.offline-secondary-button{
  position: fixed;
  top: 57%;
  right: 23px;
  transform: translateY(-50%);
  background-color: rgb(216, 13, 13) !important;
  opacity: 1 !important;
  cursor: auto;
}
</style>
